import React from "react"
import PDF from "@/public/icons/PDF-ANN.svg"
import Downlaod from "@/public/icons/download-dark-gray.svg"
import ThreeD from "@/public/icons/download-dark-gray.svg"
import TwoDPlan from "@/public/icons/download-dark-gray.svg"
import TwoDFront from "@/public/icons/download-dark-gray.svg"
import TwoDSide from "@/public/icons/2d-side-gray.svg"
import ExternalLink from "@/public/icons/external-link.svg"
import { addDataLayer } from "../ProductDetailView/analytics"

const TabTechnical = ({
  technicalData,
  staticTexts,
  authorData,
  isCurated,
  productInfo,
}) => {
  const { dwg, dxf } = staticTexts
  return (
    <div className="title-info tech-info">
      {technicalData &&
        technicalData.length > 0 &&
        technicalData.map((technical, index) => {
          if (
            (technical.description && technical.description.length > 0) ||
            (technical.specSheet && technical.specSheet.length > 0) ||
            (technical.installation && technical.installation.length > 0) ||
            (technical.threeDRevit && technical.threeDRevit.length > 0) ||
            (technical.twodDWGPlanView &&
              technical.twodDWGPlanView.length > 0) ||
            (technical.DXFPlanView && technical.DXFPlanView.length > 0) ||
            (technical.twodFrontView && technical.twodFrontView.length > 0) ||
            (technical.DXFFrontView && technical.DXFFrontView.length > 0) ||
            (technical.twoDSideView && technical.twoDSideView.length > 0) ||
            (technical.DXFSideView && technical.DXFSideView.length > 0) ||
            (technical.HomeownersGuide && technical.HomeownersGuide.length > 0)
          ) {
            return (
              <div
                key={`technical-${index}`}
                className={
                  technical.brandName
                    ? "info-row info-row-content"
                    : "info-row-content"
                }
              >
                <div className="cont-col">
                  {isCurated && (
                    <h3 className="title">
                      {`${technical.brandName || ""} ${
                        technical.category || ""
                      }`}
                    </h3>
                  )}
                  <ul>
                    {technical.description &&
                      technical.description?.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                  </ul>
                  {/* Wet Floor Application */}
                  {authorData.wetFlooring?.length > 0 &&
                    authorData.wetFlooring
                      .filter(
                        brand =>
                          brand.businessUnit?.toLowerCase() ===
                          technical.brandName?.toLowerCase()
                      )
                      .map((matchingBrand, index) => (
                        <div
                          key={`matchingBrand-${index}`}
                          className="wetfloor"
                        >
                          <p className="wetFlooringTitle">
                            {matchingBrand.title ? matchingBrand.title : ""}
                          </p>
                          <div className="link-block">
                            <img src={ExternalLink?.src} className="linkicon" />
                            <a
                              href={
                                matchingBrand.link
                                  ? matchingBrand.link
                                  : "javascript:void(0)"
                              }
                              target="_blank"
                              title={
                                matchingBrand.title ? matchingBrand.title : ""
                              }
                              className="link"
                              onClick={() => {
                                addDataLayer({
                                  title: matchingBrand?.label?.toLowerCase(),
                                  isTechnicalTab: true,
                                  productInfo,
                                  url: `${
                                    window?.location?.origin +
                                    matchingBrand?.link
                                  }`,
                                })
                              }}
                            >
                              {matchingBrand.label ? matchingBrand.label : ""}
                            </a>
                          </div>
                        </div>
                      ))}
                </div>

                <div className="pdf-col">
                  {technical.specSheet && technical.specSheet.length > 0 && (
                    <>
                      <div className="files">
                        <h4 className="heading">{staticTexts.specification}</h4>
                        <a
                          href={technical.specSheet}
                          target="_blank"
                          className="uploadFile"
                          rel="noreferrer"
                        >
                          <span className="pdfWrapper">
                            <img src={PDF?.src} />
                            <span>{staticTexts.specsSheet}</span>
                          </span>
                          <img src={Downlaod?.src} />
                        </a>
                      </div>
                    </>
                  )}

                  {/* installation */}
                  {technical.installation &&
                    technical.installation.length > 0 && (
                      <div className="files">
                        <h4 className="heading">
                          {staticTexts.Installation
                            ? staticTexts.Installation
                            : ""}
                        </h4>
                        <a
                          href={technical.installation}
                          target="_blank"
                          className="uploadFile"
                          rel="noreferrer"
                        >
                          <span className="pdfWrapper">
                            <img src={PDF?.src} />
                            <span>
                              {staticTexts.Installation
                                ? staticTexts.Installation
                                : ""}
                            </span>
                          </span>
                          <img src={Downlaod?.src} />
                        </a>
                      </div>
                    )}
                  {/* CAD Drawings */}
                  {technical.threeDRevit ||
                  technical.twodDWGPlanView ||
                  technical.DXFPlanView ||
                  technical.twodFrontView ||
                  technical.DXFFrontView ||
                  technical.twoDSideView ||
                  technical.DXFSideView ? (
                    <div className="files drawing_pdf">
                      <h4 className="heading">
                        {staticTexts.cadDrawings ? staticTexts.cadDrawings : ""}
                      </h4>
                      <div className="items" key={`Drawing-${index}`}>
                        {/* 3d file */}
                        {technical.threeDRevit &&
                          technical.threeDRevit.length > 0 && (
                            <a
                              href={technical.threeDRevit[0]}
                              target="_blank"
                              className="uploadFile"
                              rel="noreferrer"
                            >
                              <span className="pdfWrapper">
                                <img src={ThreeD?.src} />
                                <span>
                                  {staticTexts.threeDfile
                                    ? staticTexts.threeDfile
                                    : ""}
                                </span>
                              </span>
                              <img src={Downlaod?.src} />
                            </a>
                          )}
                        {/* 2d plan view */}
                        {technical.twodDWGPlanView &&
                          technical.twodDWGPlanView.length > 0 && (
                            <a
                              href={technical.twodDWGPlanView[0]}
                              target="_blank"
                              className="uploadFile"
                              rel="noreferrer"
                            >
                              <span className="pdfWrapper">
                                <img src={TwoDPlan?.src} />
                                <span>
                                  {staticTexts.twoDplan
                                    ? `${staticTexts.twoDplan} ${dwg}`
                                    : ""}
                                </span>
                              </span>
                              <img src={Downlaod?.src} />
                            </a>
                          )}
                        {technical.DXFPlanView &&
                          technical.DXFPlanView.length > 0 && (
                            <a
                              href={technical.DXFPlanView[0]}
                              target="_blank"
                              className="uploadFile"
                              rel="noreferrer"
                            >
                              <span className="pdfWrapper">
                                <img src={TwoDPlan?.src} />
                                <span>
                                  {staticTexts.twoDplan
                                    ? `${staticTexts.twoDplan} ${dxf}`
                                    : ""}
                                </span>
                              </span>
                              <img src={Downlaod?.src} />
                            </a>
                          )}
                        {/* 2d FrontView */}
                        {technical.twodFrontView &&
                          technical.twodFrontView.length > 0 && (
                            <a
                              href={technical.twodFrontView[0]}
                              target="_blank"
                              className="uploadFile"
                              rel="noreferrer"
                            >
                              <span className="pdfWrapper">
                                <img src={TwoDFront?.src} />
                                <span>
                                  {staticTexts.twoDfront
                                    ? `${staticTexts.twoDfront} ${dwg}`
                                    : ""}
                                </span>
                              </span>
                              <img src={Downlaod?.src} />
                            </a>
                          )}
                        {technical.DXFFrontView &&
                          technical.DXFFrontView.length > 0 && (
                            <a
                              href={technical.DXFFrontView[0]}
                              target="_blank"
                              className="uploadFile"
                              rel="noreferrer"
                            >
                              <span className="pdfWrapper">
                                <img src={TwoDFront?.src} />
                                <span>
                                  {staticTexts.twoDfront
                                    ? `${staticTexts.twoDfront} ${dxf}`
                                    : ""}
                                </span>
                              </span>
                              <img src={Downlaod?.src} />
                            </a>
                          )}
                        {/* 2D side view */}
                        {technical.twoDSideView &&
                          technical.twoDSideView.length > 0 && (
                            <a
                              href={technical.twoDSideView[0]}
                              target="_blank"
                              className="uploadFile"
                              rel="noreferrer"
                            >
                              <span className="pdfWrapper">
                                <img src={TwoDSide?.src} />
                                <span>
                                  {staticTexts.twoDside
                                    ? `${staticTexts.twoDside} ${dwg}`
                                    : ""}
                                </span>
                              </span>
                              <img src={Downlaod?.src} />
                            </a>
                          )}
                        {technical.DXFSideView &&
                          technical.DXFSideView.length > 0 && (
                            <a
                              href={technical.DXFSideView[0]}
                              target="_blank"
                              className="uploadFile"
                              rel="noreferrer"
                            >
                              <span className="pdfWrapper">
                                <img src={TwoDSide?.src} />
                                <span>
                                  {staticTexts.twoDside
                                    ? `${staticTexts.twoDside} ${dxf}`
                                    : ""}
                                </span>
                              </span>
                              <img src={Downlaod?.src} />
                            </a>
                          )}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            )
          } else {
            return null
          }
        })}
    </div>
  )
}

export default TabTechnical
